import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export function useDisputeTimeline(disputeId) {
  return useQuery({
    queryKey: ['admin', 'dispute', 'timeline', disputeId],
    queryFn: async () => {
      if (!disputeId) return null;
      const token = localStorage.getItem('token');
      const { data } = await axios.get(
        `${API_BASE}/api/disputes/${disputeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Extract timeline from dispute data
      return { events: data.timeline || [] };
    },
    enabled: !!disputeId,
    staleTime: 2 * 60 * 1000,
  });
}
